import React from 'react';
const images = 
[
  {
    header: 'Front of Adobe House',
    tag: <img
      src="https://centinelaadobe.org/images/Adobefront.jpg"
      alt="Front of Adobe House"
      title="Front of Adobe House"
      className="w3-circle w3-animate-opacity w3-image"></img>
  },
  {
    header: 'Daniel Freeman Land Office',
    tag: <img
      src="https://centinelaadobe.org/images/danielfreemanlandoffice.jpg"
      alt="Daniel Freeman Land Office"
      title="Daniel Freeman Land Office"
      className="w3-circle w3-animate-opacity w3-image"></img>
  },
  {
    header: 'Walter Haskel Heritage Center',
    tag: <img
      src="https://centinelaadobe.org/images/walterhaskelheritagecenter.jpg"
      alt="Walter Haskel Heritage Center"
      title="Walter Haskel Heritage Center"
      className="w3-circle w3-animate-opacity w3-image"></img>
  },
  {
    header: 'Back Walkway',
    tag: <img
      src="https://centinelaadobe.org/images/backWalkway.jpg"
      alt="Back Walkway"
      title="Back Walkway"
      style={{ height: '28.75em', width: '36.25em' }}
      className="w3-circle w3-animate-opacity w3-image"></img>
  }
];
export default images;
